import React from 'react';
import { Row, Col } from 'reactstrap';
import { Input } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import '../../../../animal-card.css';
import '../../../../tabs/animal-card-tab.css';
import '../../entries-tabs.css';
import TabNavButtons from '../../tab-nav-buttons';

const PhysiologyTab = props => {
  const options = [1, 2, 3, 4, 5];
  return (
    <div className="tab">
      <form>
        <Row>
          <Col lg='12'>
            <div className="tab-head d-flex justify-content-between">
              <div>
                <div className="d-flex align-items-baseline">
                  <h3 className="mr-3">| ДАННИ ЗА МЪЖКИ |</h3>
                  <button className="button-icon icon-color-success">
                    <FontAwesomeIcon icon={'question-circle'} />
                  </button>
                </div>
                <p className="info-text-red" >Физиологично състояние и показатели мъжки!</p>
              </div>
            </div>
          </Col>
          <Col lg='8'>
            <Row>
              <Col lg='3'>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Размер скротум</label>
                  <Input />
                </div>
              </Col>
              <Col lg='3'>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Кастрирано</label>
                  <DropDownList data={options} defaultValue="1" />
                </div>
              </Col>
              <Col lg='3'>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">ОТС</label>
                  <DropDownList data={options} defaultValue="1" />
                </div>
              </Col>
              <Col lg='3'>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Зъбна формула</label>
                  <DropDownList data={options} defaultValue="1" />
                </div>
              </Col>
              <Col lg='3'>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Тегло @0</label>
                  <Input />
                </div>
              </Col>
              <Col lg='3'>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Тегло @200</label>
                  <Input />
                </div>
              </Col>
              <Col lg='3'>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Тегло @365</label>
                  <Input />
                </div>
              </Col>
              <Col lg='3'>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Тегло @550</label>
                  <Input />
                </div>
              </Col>
            </Row>
          </Col>
          <Col lg='4'>
            <div className="form-group">
              <label htmlFor="exampleText">Описание</label>
              <textarea className="k-textarea fixed-height" rows="4" />
            </div>
          </Col>

          <Col lg='12'>
            <div className="tab-head d-flex justify-content-between">
              <div>
                <div className="d-flex align-items-baseline">
                  <h3 className="mr-3">| ДАННИ ЗА ЖЕНСКИ |</h3>
                  <button className="button-icon icon-color-success">
                    <FontAwesomeIcon icon={'question-circle'} />
                  </button>
                </div>
                <p className="info-text-red" >Физиологично състояние и показатели женски!</p>
              </div>
            </div>
          </Col>
          <Col lg='8'>
            <Row>
              <Col lg='3'>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Брой отелвания</label>
                  <Input />
                </div>
              </Col>
              <Col lg='3'>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Репродуктивен статус</label>
                  <DropDownList data={options} defaultValue="1" />
                </div>
              </Col>
              <Col lg='3'>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">СРР</label>
                  <DropDownList data={options} defaultValue="1" />
                </div>
              </Col>
              <Col lg='3'>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Зъбна формула</label>
                  <DropDownList data={options} defaultValue="1" />
                </div>
              </Col>
              <Col lg='3'>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Тегло @0</label>
                  <Input />
                </div>
              </Col>
              <Col lg='3'>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Тегло @200</label>
                  <Input />
                </div>
              </Col>
              <Col lg='3'>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Тегло @365</label>
                  <Input />
                </div>
              </Col>
              <Col lg='3'>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Тегло @550</label>
                  <Input />
                </div>
              </Col>
            </Row>
          </Col>
          <Col lg='4'>
            <div className="form-group">
              <label htmlFor="exampleText">Описание</label>
              <textarea className="k-textarea fixed-height" rows="4" />
            </div>
          </Col>
        </Row>

         <TabNavButtons parentProps ={props}/>
      </form>

    </div>
  )
};

export default PhysiologyTab;